import { FC, SVGProps } from 'react';

export const CalendarWithDatesIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			d="M20.5932 16.7C20.03 16.7 19.5735 17.1565 19.5735 17.7197C19.5735 18.2828 20.03 18.7393 20.5932 18.7393H20.6057C21.1689 18.7393 21.6254 18.2828 21.6254 17.7197C21.6254 17.1565 21.1689 16.7 20.6057 16.7H20.5932Z"
			fill="currentColor"
		/>
		<path
			d="M14.5421 17.7197C14.5421 17.1565 14.9986 16.7 15.5618 16.7H15.5743C16.1375 16.7 16.594 17.1565 16.594 17.7197C16.594 18.2828 16.1375 18.7393 15.5743 18.7393H15.5618C14.9986 18.7393 14.5421 18.2828 14.5421 17.7197Z"
			fill="currentColor"
		/>
		<path
			d="M10.5197 16.7C9.95652 16.7 9.50002 17.1565 9.50002 17.7197C9.50002 18.2828 9.95652 18.7393 10.5197 18.7393H10.5322C11.0954 18.7393 11.5519 18.2828 11.5519 17.7197C11.5519 17.1565 11.0954 16.7 10.5322 16.7H10.5197Z"
			fill="currentColor"
		/>
		<path
			d="M14.5421 22.1815C14.5421 21.6184 14.9986 21.1618 15.5618 21.1618H15.5743C16.1375 21.1618 16.594 21.6184 16.594 22.1815C16.594 22.7446 16.1375 23.2011 15.5743 23.2011H15.5618C14.9986 23.2011 14.5421 22.7446 14.5421 22.1815Z"
			fill="currentColor"
		/>
		<path
			d="M10.5197 21.1618C9.95652 21.1618 9.50002 21.6184 9.50002 22.1815C9.50002 22.7446 9.95652 23.2011 10.5197 23.2011H10.5322C11.0954 23.2011 11.5519 22.7446 11.5519 22.1815C11.5519 21.6184 11.0954 21.1618 10.5322 21.1618H10.5197Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.4318 5.29545H12.5682V5C12.5682 4.58579 12.2324 4.25 11.8182 4.25C11.404 4.25 11.0682 4.58579 11.0682 5V5.29545H9.54547C6.92212 5.29545 4.79547 7.4221 4.79547 10.0455V24C4.79547 26.6234 6.92211 28.75 9.54547 28.75H22.4546C25.0779 28.75 27.2046 26.6233 27.2046 24V10.0455C27.2046 7.4221 25.0779 5.29545 22.4546 5.29545H20.9318V5C20.9318 4.58579 20.5961 4.25 20.1818 4.25C19.7676 4.25 19.4318 4.58579 19.4318 5V5.29545ZM20.1818 8.5C19.7676 8.5 19.4318 8.16421 19.4318 7.75V6.79545H12.5682V7.75C12.5682 8.16421 12.2324 8.5 11.8182 8.5C11.404 8.5 11.0682 8.16421 11.0682 7.75V6.79545H9.54547C7.75055 6.79545 6.29547 8.25053 6.29547 10.0455V12.25H25.7046V10.0455C25.7046 8.25053 24.2495 6.79545 22.4546 6.79545H20.9318V7.75C20.9318 8.16421 20.5961 8.5 20.1818 8.5ZM25.7046 13.75H6.29547V24C6.29547 25.7949 7.75054 27.25 9.54547 27.25H22.4546C24.2495 27.25 25.7046 25.7949 25.7046 24V13.75Z"
			fill="currentColor"
		/>
	</svg>
);
